import { useAppTheme } from "@hooks/useAppTheme";
import { Box, MarkdownRenderer } from "@memorang/ui";
import { Icon, Text } from "react-native-paper";

interface Props {
	text: string;
	title?: string;
}

/**
 * Renders lesson content inside a visually highlighted card: a tinted surface
 * with a left accent border and a "Lesson" eyebrow, so the lesson reads as a
 * distinct, important block rather than plain body text.
 */
const Lesson = ({ text, title = "Learn" }: Props) => {
	const theme = useAppTheme();

	if (!text) {
		return null;
	}

	return (
		<Box
			borderWidth={1}
			borderColor={theme.colors.outlineVariant}
			borderRadius={theme.roundness}
			backgroundColor={theme.colors.surfaceVariant}
			padding={20}
			gap={12}
			style={{
				borderLeftWidth: 4,
				borderLeftColor: theme.colors.primary,
			}}
		>
			<Box flexDirection="row" alignItems="center" gap={8}>
				<Icon
					source="book-open-variant"
					size={20}
					color={theme.colors.primary}
				/>
				<Text
					variant="labelLarge"
					style={{
						color: theme.colors.primary,
						textTransform: "uppercase",
						letterSpacing: 0.6,
						fontWeight: "700",
					}}
				>
					{title}
				</Text>
			</Box>
			<MarkdownRenderer
				text={text}
				fontSize={16}
				customStyles={{
					text: { lineHeight: 26 },
					paragraph: { lineHeight: 26, marginTop: 0, marginBottom: 16 },
				}}
			/>
		</Box>
	);
};

export default Lesson;
